import { render, staticRenderFns } from "./secondaryPagesPPJS.vue?vue&type=template&id=dc38c450&scoped=true&"
import script from "./secondaryPagesPPJS.vue?vue&type=script&lang=js&"
export * from "./secondaryPagesPPJS.vue?vue&type=script&lang=js&"
import style0 from "./secondaryPagesPPJS.vue?vue&type=style&index=0&id=dc38c450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc38c450",
  null
  
)

export default component.exports